var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.venta.fecha))]),_c('td',[_vm._v(_vm._s(_vm.venta.nombre)+" "+_vm._s(_vm.venta.apellido))]),_c('td',[_vm._v(_vm._s(_vm.venta.email))]),_c('td',[_vm._v(_vm._s(_vm.venta.descripcion))]),_c('td',[_vm._v(_vm._s(_vm.venta.mercadopago_id))]),_c('td',[_vm._v("$ "+_vm._s(_vm.dotsCadaTres(_vm.venta.precio)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }